/**
 * KIYA SILVER JEWELLERY - LUXURY SHOPIFY THEME JS
 * Pure JavaScript supporting native Shopify AJAX Cart, Variant updates & drawer state.
 */

function initKiyaTheme() {
  try { initStickyHeader(); } catch (e) { console.error('initStickyHeader:', e); }
  try { initCartDrawer(); } catch (e) { console.error('initCartDrawer:', e); }
  try { initSearchModal(); } catch (e) { console.error('initSearchModal:', e); }
  try { initMobileNav(); } catch (e) { console.error('initMobileNav:', e); }
  try { initVariantSelectors(); } catch (e) { console.error('initVariantSelectors:', e); }
  try { initAccordions(); } catch (e) { console.error('initAccordions:', e); }
  try { initInstagramReels(); } catch (e) { console.error('initInstagramReels:', e); }
  try { initWishlistButtons(); } catch (e) { console.error('initWishlistButtons:', e); }
  try { updateWishlistBadges(); } catch (e) { console.error('updateWishlistBadges:', e); }
  try { renderWishlistPage(); } catch (e) { console.error('renderWishlistPage:', e); }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKiyaTheme);
} else {
  initKiyaTheme();
}

/* ==========================================================================
   STICKY HEADER TRANSITION
   ========================================================================== */
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }, { passive: true });
}

/* ==========================================================================
   CART DRAWER & NATIVE SHOPIFY AJAX CART API
   ========================================================================== */
function initCartDrawer() {
  const cartBackdrop = document.querySelector('.cart-drawer-backdrop');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartCloses = document.querySelectorAll('[data-cart-close]');

  if (!cartBackdrop) return;

  function openCart() {
    cartBackdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    fetchAndRenderCart();
  }

  function closeCart() {
    cartBackdrop.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  cartCloses.forEach(btn => btn.addEventListener('click', closeCart));

  cartBackdrop.addEventListener('click', (e) => {
    if (e.target === cartBackdrop) closeCart();
  });

  // Global Quick Add handler
  document.body.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('[data-quick-add]');
    if (!addBtn) return;

    // Skip if button is inside product detail form to prevent double submission
    if (addBtn.closest('form[action*="/cart/add"]') || addBtn.getAttribute('type') === 'submit') {
      return;
    }

    e.preventDefault();
    const variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    // Detect selected quantity from quantity selector input
    let quantity = 1;
    const purchaseArea = addBtn.closest('.product-purchase-area, .product-qty-add-row, .product-actions-form') || document;
    const qtyInput = purchaseArea.querySelector('.qty-input, input[name="quantity"]');
    if (qtyInput) {
      const parsedQty = parseInt(qtyInput.value, 10);
      if (!isNaN(parsedQty) && parsedQty > 0) {
        quantity = parsedQty;
      }
    }

    const originalText = addBtn.innerHTML;
    addBtn.innerHTML = 'ADDING...';
    addBtn.disabled = true;

    try {
      await addToCartAJAX(variantId, quantity);
      await fetchAndRenderCart();
      openCart();
    } catch (err) {
      console.error('Add to cart failed:', err);
      // Fallback: local cart state update for standalone local preview mode
      addToLocalPreviewCart(variantId, quantity);
      openCart();
    } finally {
      addBtn.innerHTML = originalText;
      addBtn.disabled = false;
    }
  });

  // Handle Product Detail Form AJAX submission with Quantity (Runs ONCE per click)
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      const submitBtn = productForm.querySelector('[type="submit"], .btn-add-to-bag');
      const originalText = submitBtn ? submitBtn.innerHTML : 'ADD TO BAG';
      if (submitBtn) {
        submitBtn.innerHTML = 'ADDING...';
        submitBtn.disabled = true;
      }
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (!response.ok) {
          throw new Error('Form submit failed');
        }
        await fetchAndRenderCart();
        openCart();
      } catch (err) {
        // Fallback for standalone local preview mode
        const variantId = formData.get('id') || '101';
        const qty = parseInt(formData.get('quantity') || '1', 10);
        addToLocalPreviewCart(variantId, qty);
        openCart();
      } finally {
        if (submitBtn) {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }
      }
    });
  }

  // Handle BUY IT NOW Express Checkout (Adds Exact Selected Quantity ONCE & Direct Checkout)
  document.addEventListener('click', async (e) => {
    const buyNowBtn = e.target.closest('[data-buy-now], .btn-buy-now-express');
    if (!buyNowBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const form = buyNowBtn.closest('form') || document.querySelector('form[action*="/cart/add"]') || document.querySelector('#productForm');
    const formData = form ? new FormData(form) : new FormData();

    const variantId = formData.get('id') || buyNowBtn.getAttribute('data-variant-id') || '101';
    let quantity = 1;
    const qtyInput = form ? form.querySelector('.qty-input, input[name="quantity"]') : document.querySelector('.qty-input');
    if (qtyInput) {
      const parsedQty = parseInt(qtyInput.value, 10);
      if (!isNaN(parsedQty) && parsedQty > 0) {
        quantity = parsedQty;
      }
    }

    const originalText = buyNowBtn.innerHTML;
    buyNowBtn.innerHTML = 'PROCESSING...';
    buyNowBtn.disabled = true;

    try {
      await addToCartAJAX(variantId, quantity);
      await fetchAndRenderCart();
      window.location.href = '/checkout';
    } catch (err) {
      console.error('Buy Now failed:', err);
      addToLocalPreviewCart(variantId, quantity);
      openCart();
    } finally {
      buyNowBtn.innerHTML = originalText;
      buyNowBtn.disabled = false;
    }
  });

  // Universal Quantity (+ / -) Button Click Handler (Product Detail Page & Purchase Area)
  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('.qty-btn, [data-qty-btn]');
    if (!qtyBtn) return;

    // Ignore cart drawer & cart page buttons which have dedicated handlers
    if (
      qtyBtn.hasAttribute('data-cart-page-change') || 
      qtyBtn.hasAttribute('data-cart-page-qty') || 
      qtyBtn.hasAttribute('data-qty-change')
    ) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    // Locate the qty-input within the same selector row or form
    const qtyBox = qtyBtn.closest('.qty-selector, .product-qty-add-row, .product-purchase-area, form') || qtyBtn.parentElement;
    const input = qtyBox ? qtyBox.querySelector('.qty-input, input[name="quantity"]') : null;

    if (input) {
      let val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) val = 1;

      const txt = qtyBtn.textContent.trim();
      const isMinus = txt === '-' || txt === '−' || qtyBtn.classList.contains('qty-minus') || qtyBtn.classList.contains('qty-minus-btn');

      if (isMinus) {
        if (val > 1) input.value = val - 1;
      } else {
        input.value = val + 1;
      }

      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Global quantity & remove listeners inside Cart Drawer
  const cartItemsContainer = document.querySelector('.cart-drawer-items');
  if (cartItemsContainer) {
    cartItemsContainer.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-qty-change]');
      const removeBtn = e.target.closest('[data-item-remove]');

      if (qtyBtn) {
        const line = qtyBtn.getAttribute('data-line');
        const currentQty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        const change = parseInt(qtyBtn.getAttribute('data-change'), 10);
        const newQty = Math.max(0, currentQty + change);
        await updateCartLine(line, newQty);
      } else if (removeBtn) {
        const line = removeBtn.getAttribute('data-line');
        await updateCartLine(line, 0);
      }
    });
  }

  // Instant Cart Page (+ / - / Remove) AJAX Handler (NO Page Reload!)
  document.addEventListener('click', async (e) => {
    const pageQtyBtn = e.target.closest('[data-cart-page-change], [data-cart-page-qty]');
    const pageRemoveBtn = e.target.closest('[data-cart-page-remove]');

    if (!pageQtyBtn && !pageRemoveBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const targetBtn = pageQtyBtn || pageRemoveBtn;
    const itemRow = targetBtn.closest('[data-item-key]') || targetBtn.closest('div[style*="grid"]');
    const key = targetBtn.getAttribute('data-key');
    const line = targetBtn.getAttribute('data-line');

    let newQty = 0;
    if (pageQtyBtn) {
      const currentQty = parseInt(pageQtyBtn.getAttribute('data-qty') || '1', 10);
      const change = parseInt(pageQtyBtn.getAttribute('data-cart-page-change') || pageQtyBtn.getAttribute('data-change') || '0', 10);
      newQty = Math.max(0, currentQty + change);
    }

    // Instant local UI feedback
    const qtyInput = itemRow ? itemRow.querySelector('.qty-input') : null;
    if (qtyInput && pageQtyBtn) {
      qtyInput.value = newQty;
    }
    if (pageQtyBtn && itemRow) {
      const minusBtn = itemRow.querySelector('[data-cart-page-change="-1"]');
      const plusBtn = itemRow.querySelector('[data-cart-page-change="1"]');
      if (minusBtn) minusBtn.setAttribute('data-qty', newQty);
      if (plusBtn) plusBtn.setAttribute('data-qty', newQty);
    }

    try {
      const payload = key ? { id: key, quantity: newQty } : { line: parseInt(line, 10), quantity: newQty };
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        const cart = await response.json();
        updateCartPageUI(cart, itemRow, key, line, newQty);
        renderCartData(cart);
      } else {
        updateLocalPreviewCartPage(itemRow, line, newQty);
      }
    } catch (err) {
      updateLocalPreviewCartPage(itemRow, line, newQty);
    }
  });

  window.kiyaCart = { openCart, closeCart, fetchAndRenderCart };
}

function updateCartPageUI(cart, itemRow, key, line, newQty) {
  // Update Subtotal on Cart Page
  const pageSubtotal = document.querySelector('[data-cart-page-subtotal]');
  if (pageSubtotal && cart.total_price !== undefined) {
    pageSubtotal.textContent = formatMoney(cart.total_price);
  }

  // Update Header Badges
  const badges = document.querySelectorAll('.cart-count-badge');
  badges.forEach(b => b.textContent = cart.item_count || 0);

  // Update Item Line Total or remove row if quantity is 0
  if (newQty === 0 && itemRow) {
    itemRow.style.transition = 'all 0.3s ease';
    itemRow.style.opacity = '0';
    setTimeout(() => itemRow.remove(), 300);
  } else if (itemRow) {
    const lineTotalEl = itemRow.querySelector('[data-cart-page-line-total]');
    const itemData = cart.items ? cart.items.find(i => (key && i.key === key) || String(i.line) === String(line)) : null;
    if (lineTotalEl && itemData) {
      lineTotalEl.textContent = formatMoney(itemData.final_line_price || (itemData.price * itemData.quantity));
    }
  }
}

function updateLocalPreviewCartPage(itemRow, lineIndex, newQty) {
  updateLocalPreviewCartLine(parseInt(lineIndex, 10), newQty);
  const cart = getLocalPreviewCart();
  updateCartPageUI(cart, itemRow, null, lineIndex, newQty);
}

async function addToCartAJAX(variantId, quantity = 1) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  });
  if (!response.ok) {
    throw new Error('AJAX add to cart failed');
  }
  return await response.json();
}

async function updateCartLine(lineKey, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(lineKey, 10), quantity: quantity })
    });
    if (response.ok) {
      const cart = await response.json();
      renderCartData(cart);
    } else {
      updateLocalPreviewCartLine(parseInt(lineKey, 10), quantity);
    }
  } catch (err) {
    updateLocalPreviewCartLine(parseInt(lineKey, 10), quantity);
  }
}

function submitNativeShopifyCartFormPOST(key, lineKey, quantity) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/cart'; // Native Shopify Cart POST endpoint (never /cart/change GET)
  
  const updateInput = document.createElement('input');
  updateInput.type = 'hidden';
  updateInput.name = key ? `updates[${key}]` : `updates[${lineKey}]`;
  updateInput.value = quantity;
  
  form.appendChild(updateInput);
  document.body.appendChild(form);
  form.submit();
}

// Local Cart Storage Fallback (Standalone HTML Preview Mode)
function getLocalPreviewCart() {
  try {
    return JSON.parse(localStorage.getItem('kiya_local_cart') || '{"items":[],"item_count":0,"total_price":0}');
  } catch (e) {
    return { items: [], item_count: 0, total_price: 0 };
  }
}

function saveLocalPreviewCart(cart) {
  try {
    let itemCount = 0;
    let totalPrice = 0;
    cart.items.forEach(item => {
      itemCount += item.quantity;
      totalPrice += (item.price || 289900) * item.quantity;
    });
    cart.item_count = itemCount;
    cart.total_price = totalPrice;
    localStorage.setItem('kiya_local_cart', JSON.stringify(cart));
    renderCartData(cart);
  } catch (e) {}
}

function addToLocalPreviewCart(variantId, quantity = 1) {
  const cart = getLocalPreviewCart();
  const existingIndex = cart.items.findIndex(i => String(i.id) === String(variantId) || String(i.variant_id) === String(variantId));
  if (existingIndex > -1) {
    cart.items[existingIndex].quantity += quantity;
  } else {
    const prodInfo = window.PRODUCTS_CATALOG ? window.PRODUCTS_CATALOG[String(variantId)] : null;
    const priceCents = 289900;
    cart.items.push({
      id: variantId,
      variant_id: variantId,
      title: prodInfo ? prodInfo.name : `Royal 925 Sterling Silver Piece #${variantId}`,
      product_title: prodInfo ? prodInfo.name : `Royal 925 Sterling Silver Piece #${variantId}`,
      price: priceCents,
      quantity: quantity,
      final_line_price: priceCents * quantity,
      image: prodInfo ? prodInfo.image : 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?q=80&w=600'
    });
  }
  saveLocalPreviewCart(cart);
}

function updateLocalPreviewCartLine(lineIndex, quantity) {
  const cart = getLocalPreviewCart();
  const index = lineIndex - 1;
  if (cart.items[index]) {
    if (quantity <= 0) {
      cart.items.splice(index, 1);
    } else {
      cart.items[index].quantity = quantity;
      cart.items[index].final_line_price = cart.items[index].price * quantity;
    }
    saveLocalPreviewCart(cart);
  }
}

async function fetchAndRenderCart() {
  try {
    const response = await fetch('/cart.js');
    if (response.ok) {
      const cart = await response.json();
      renderCartData(cart);
      return;
    }
  } catch (err) {}
  renderCartData(getLocalPreviewCart());
}

function renderCartData(cart) {
  // Update header badges
  const badges = document.querySelectorAll('.cart-count-badge');
  badges.forEach(b => b.textContent = cart.item_count || 0);

  // Update Cart Drawer items
  const itemsContainer = document.querySelector('.cart-drawer-items');
  const subtotalEl = document.querySelector('[data-cart-subtotal]');

  if (subtotalEl && cart.total_price !== undefined) {
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  if (!itemsContainer) return;

  if (!cart.items || cart.items.length === 0) {
    itemsContainer.innerHTML = `
      <div style="text-align: center; padding: 4rem 1rem;">
        <p style="font-family: var(--font-heading); font-size: 1.5rem; margin-bottom: 1rem;">Your shopping bag is empty.</p>
        <a href="/collections/all" class="btn-primary" style="padding: 0.75rem 1.5rem;">EXPLORE COLLECTIONS</a>
      </div>
    `;
    return;
  }

  let html = '';
  cart.items.forEach((item, index) => {
    const lineNum = index + 1;
    const itemPrice = formatMoney(item.final_line_price || item.price * item.quantity);

    html += `
      <div class="cart-item">
        <img class="cart-item-img" src="${item.image || 'assets/kiya-logo.jpg'}" alt="${item.title}">
        <div class="cart-item-details">
          <div class="cart-item-title">${item.product_title || item.title}</div>
          ${item.variant_title ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="cart-item-price">${itemPrice}</div>
          <div class="cart-item-actions">
            <div class="qty-selector">
              <button class="qty-btn" data-qty-change data-line="${lineNum}" data-qty="${item.quantity}" data-change="-1">-</button>
              <input class="qty-input" type="text" value="${item.quantity}" readonly>
              <button class="qty-btn" data-qty-change data-line="${lineNum}" data-qty="${item.quantity}" data-change="1">+</button>
            </div>
            <button class="cart-item-remove" data-item-remove data-line="${lineNum}">Remove</button>
          </div>
        </div>
      </div>
    `;
  });

  itemsContainer.innerHTML = html;
}

function formatMoney(cents) {
  if (typeof cents !== 'number') return cents;
  const rupees = Math.floor(cents / 100);
  return '₹' + rupees.toLocaleString('en-IN');
}

/* ==========================================================================
   SEARCH MODAL
   ========================================================================== */
function initSearchModal() {
  const backdrop = document.querySelector('.search-modal-backdrop');
  const triggers = document.querySelectorAll('[data-search-trigger]');
  const closes = document.querySelectorAll('[data-search-close]');

  if (!backdrop) return;

  triggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    backdrop.classList.add('is-active');
    const input = backdrop.querySelector('input');
    if (input) setTimeout(() => input.focus(), 200);
  }));

  closes.forEach(c => c.addEventListener('click', () => {
    backdrop.classList.remove('is-active');
  }));
}

/* ==========================================================================
   MOBILE NAVIGATION DRAWER LOGIC
   ========================================================================== */
function initMobileNav() {
  const backdrop = document.querySelector('.mobile-nav-backdrop');
  const toggles = document.querySelectorAll('.mobile-menu-toggle, [data-mobile-menu-toggle]');
  const closeBtn = document.querySelector('.mobile-nav-close');
  const navLinks = document.querySelectorAll('.mobile-nav-link');

  if (!backdrop) return;

  function openMobileNav() {
    backdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    backdrop.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  toggles.forEach(t => {
    t.addEventListener('click', (e) => {
      e.preventDefault();
      openMobileNav();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeMobileNav();
    });
  }

  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) {
      closeMobileNav();
    }
  });

  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeMobileNav();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && backdrop.classList.contains('is-active')) {
      closeMobileNav();
    }
  });
}


/* ==========================================================================
   VARIANT SELECTOR LOGIC
   ========================================================================== */
function initVariantSelectors() {
  const variantPickers = document.querySelectorAll('[data-variant-picker]');
  
  variantPickers.forEach(picker => {
    const options = picker.querySelectorAll('.variant-option-btn');
    const hiddenInput = picker.closest('form')?.querySelector('input[name="id"]');
    const priceDisplay = document.querySelector('[data-product-price]');
    const compareDisplay = document.querySelector('[data-product-compare-price]');
    const mainImg = document.querySelector('[data-main-image]');

    options.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        options.forEach(o => o.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        const variantId = btn.getAttribute('data-variant-id');
        const price = btn.getAttribute('data-price');
        const comparePrice = btn.getAttribute('data-compare-price');
        const imgSrc = btn.getAttribute('data-image');

        if (hiddenInput && variantId) hiddenInput.value = variantId;
        if (priceDisplay && price) priceDisplay.textContent = price;
        if (compareDisplay && comparePrice) compareDisplay.textContent = comparePrice;
        if (mainImg && imgSrc) mainImg.src = imgSrc;
      });
    });
  });
}

/* ==========================================================================
   ACCORDIONS
   ========================================================================== */
function initAccordions() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      if (item) {
        item.classList.toggle('is-open');
      }
    });
  });
}

/* ==========================================================================
   INSTAGRAM REELS CAROUSEL CONTROLLER
   ========================================================================== */
function initInstagramReels() {
  const track = document.querySelector('[data-reels-track]');
  const prevBtn = document.querySelector('[data-reels-prev]');
  const nextBtn = document.querySelector('[data-reels-next]');
  const reelCards = document.querySelectorAll('.reel-card');

  if (!track) return;

  // Horizontal Carousel Nav Buttons
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -320, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: 320, behavior: 'smooth' });
    });
  }

  // Reel Video Play / Pause & Mute / Unmute
  reelCards.forEach(card => {
    const video = card.querySelector('.reel-video');
    const mediaWrapper = card.querySelector('.reel-media-wrapper');
    const audioBtn = card.querySelector('[data-audio-toggle]');
    const likeBtn = card.querySelector('[data-like-btn]');
    const shareBtn = card.querySelector('[data-share-btn]');

    if (video) {
      // Auto-play when reel is hovered / clicked
      mediaWrapper.addEventListener('mouseenter', () => {
        video.play().catch(() => {});
      });

      mediaWrapper.addEventListener('click', (e) => {
        // Prevent click if clicking on buttons or product pill
        if (e.target.closest('[data-quick-add], [data-audio-toggle], [data-like-btn], [data-share-btn]')) {
          return;
        }
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    // Audio Mute/Unmute
    if (audioBtn && video) {
      audioBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        const iconMuted = audioBtn.querySelector('.icon-muted');
        const iconPlaying = audioBtn.querySelector('.icon-playing');

        if (video.muted) {
          if (iconMuted) iconMuted.style.display = 'block';
          if (iconPlaying) iconPlaying.style.display = 'none';
        } else {
          if (iconMuted) iconMuted.style.display = 'none';
          if (iconPlaying) iconPlaying.style.display = 'block';
        }
      });
    }

    // Like Button Toggle & Counter Increment
    if (likeBtn) {
      likeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        likeBtn.classList.toggle('is-liked');
        const countSpan = likeBtn.querySelector('.like-count');
        if (countSpan) {
          let currentLikes = countSpan.getAttribute('data-raw-count');
          if (!currentLikes) {
            currentLikes = parseFloat(countSpan.textContent) * (countSpan.textContent.includes('K') ? 1000 : 1);
          } else {
            currentLikes = parseFloat(currentLikes);
          }
          if (likeBtn.classList.contains('is-liked')) {
            currentLikes += 1;
          } else {
            currentLikes = Math.max(0, currentLikes - 1);
          }
          countSpan.setAttribute('data-raw-count', currentLikes);
          countSpan.textContent = currentLikes >= 1000 ? (currentLikes / 1000).toFixed(1) + 'K' : currentLikes;
        }
      });
    }

    // Share Button
    if (shareBtn) {
      shareBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (navigator.share) {
          navigator.share({
            title: 'KIYA Silver Jewellery Reel',
            url: window.location.href
          }).catch(() => {});
        } else {
          navigator.clipboard.writeText(window.location.href);
          alert('Link copied to clipboard! Share on Instagram or WhatsApp.');
        }
      });
    }
  });
}

/* ==========================================================================
   WISHLIST INTERACTIVE TOGGLE
   ========================================================================== */
function initWishlistButtons() {
  const getWishlist = () => {
    try {
      const raw = localStorage.getItem('kiya_wishlist');
      if (!raw) return [];
      return JSON.parse(raw);
    } catch {
      return [];
    }
  };

  const setWishlist = (list) => {
    try {
      localStorage.setItem('kiya_wishlist', JSON.stringify(list));
    } catch (e) {
      console.warn('Could not access localStorage for wishlist:', e);
    }
  };

  function extractProductData(btn) {
    const card = btn.closest('.product-card, .product-card-wrapper, .featured-showcase-layout, .hero-slide, [data-product-card]');
    const pid = btn.getAttribute('data-product-id') || btn.getAttribute('data-variant-id') || (card ? card.getAttribute('data-product-id') : null) || String(Date.now());
    
    let title = btn.getAttribute('data-product-title');
    if (!title && card) {
      const titleEl = card.querySelector('.product-title, .showcase-product-title, .hero-product-name, h3, h2');
      if (titleEl) title = titleEl.innerText.trim();
    }
    title = title || `Pure 925 Silver Piece #${pid}`;

    let price = btn.getAttribute('data-product-price');
    if (!price && card) {
      const priceEl = card.querySelector('.product-price, .showcase-price, .current-price');
      if (priceEl) price = priceEl.innerText.trim();
    }
    price = price || '₹2,999.00';

    let comparePrice = btn.getAttribute('data-product-compare-price');
    if (!comparePrice && card) {
      const compEl = card.querySelector('.compare-at-price, .original-price');
      if (compEl) comparePrice = compEl.innerText.trim();
    }

    let image = btn.getAttribute('data-product-image');
    if (!image && card) {
      const imgEl = card.querySelector('img');
      if (imgEl) image = imgEl.src;
    }
    image = image || 'https://images.unsplash.com/photo-1611591475285-a36adaf961e0?q=80&w=600';

    let url = btn.getAttribute('data-product-url');
    if (!url && card) {
      const linkEl = card.querySelector('a');
      if (linkEl) url = linkEl.href;
    }
    url = url || 'product.html';

    let category = btn.getAttribute('data-product-category');
    if (!category && card) {
      const catEl = card.querySelector('.product-vendor, .showcase-vendor, .product-category-tag');
      if (catEl) category = catEl.innerText.trim();
    }
    category = category || '925 STERLING SILVER';

    return {
      id: String(pid),
      name: title,
      price: price,
      comparePrice: comparePrice || '',
      image: image,
      url: url,
      category: category,
      discount: 'SAVE 20%',
      badge: 'SAVED'
    };
  }

  // Sync initial button states
  const currentWishlist = getWishlist();
  const savedIds = currentWishlist.map(item => typeof item === 'object' ? item.id : String(item));

  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    const pid = btn.getAttribute('data-product-id');
    if (pid && savedIds.includes(String(pid))) {
      btn.classList.add('is-wishlisted');
    }
  });

  // Delegated click listener for dynamic or existing buttons
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    btn.classList.toggle('is-wishlisted');
    const pData = extractProductData(btn);
    let currentList = getWishlist();

    const isAdded = btn.classList.contains('is-wishlisted');
    if (isAdded) {
      // Add item if not present
      const exists = currentList.some(item => (typeof item === 'object' ? item.id : String(item)) === pData.id);
      if (!exists) {
        currentList.push(pData);
      }
    } else {
      // Remove item
      currentList = currentList.filter(item => (typeof item === 'object' ? item.id : String(item)) !== pData.id);
    }

    // Sync other buttons matching this product id
    document.querySelectorAll(`[data-wishlist-btn][data-product-id="${pData.id}"]`).forEach(b => {
      if (isAdded) {
        b.classList.add('is-wishlisted');
      } else {
        b.classList.remove('is-wishlisted');
      }
    });

    setWishlist(currentList);
    updateWishlistBadges();
    renderWishlistPage();
  });
}

/* ==========================================================================
   DYNAMIC WISHLIST PAGE & BADGES SYSTEM
   ========================================================================== */
const PRODUCTS_CATALOG = {
  "101": {
    id: "101",
    name: "Kiya Grace Solitaire Silver Bangle",
    category: "SIGNATURE BANGLE",
    price: "₹3,538.82",
    comparePrice: "₹4,364.02",
    discount: "19% OFF",
    image: "https://images.unsplash.com/photo-1611591475285-a36adaf961e0?q=80&w=600",
    badge: "POPULAR CHOICE"
  },
  "102": {
    id: "102",
    name: "Empress Emerald Silver Pendant",
    category: "ROYAL NECKLACE",
    price: "₹4,299.00",
    comparePrice: "₹5,499.00",
    discount: "21% OFF",
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?q=80&w=600",
    badge: "ROYAL EDITION"
  },
  "103": {
    id: "103",
    name: "Celestial Princess Cut Silver Ring",
    category: "SOLITAIRE RING",
    price: "₹2,899.00",
    comparePrice: "₹3,699.00",
    discount: "22% OFF",
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?q=80&w=600",
    badge: "BEST SELLER"
  },
  "104": {
    id: "104",
    name: "Vintage Pearl Silver Earrings",
    category: "EARRINGS",
    price: "₹2,499.00",
    comparePrice: "₹3,199.00",
    discount: "21% OFF",
    image: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?q=80&w=600",
    badge: "CLASSIC PEARL"
  },
  "201": {
    id: "201",
    name: "Royal Crown CZ Silver Ring",
    category: "RINGS",
    price: "₹1,899.00",
    comparePrice: "₹2,499.00",
    discount: "24% OFF",
    image: "https://images.unsplash.com/photo-1603561591411-07134e71a2a9?q=80&w=600",
    badge: "NEW"
  },
  "202": {
    id: "202",
    name: "Silver Choker Pearl Necklace Set",
    category: "NECKLACE",
    price: "₹5,499.00",
    comparePrice: "₹6,999.00",
    discount: "21% OFF",
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?q=80&w=600",
    badge: "HERITAGE"
  },
  "203": {
    id: "203",
    name: "Floral Stud Sterling Silver Earrings",
    category: "EARRINGS",
    price: "₹1,299.00",
    comparePrice: "₹1,799.00",
    discount: "27% OFF",
    image: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?q=80&w=600",
    badge: "DAILY WEAR"
  },
  "204": {
    id: "204",
    name: "Adjustable Silver Cuff Bracelet",
    category: "BRACELET",
    price: "₹2,799.00",
    comparePrice: "₹3,499.00",
    discount: "20% OFF",
    image: "https://images.unsplash.com/photo-1611591475285-a36adaf961e0?q=80&w=600",
    badge: "TRENDING"
  }
};

function getWishlistList() {
  try {
    const raw = localStorage.getItem('kiya_wishlist');
    if (!raw) return [];
    return JSON.parse(raw);
  } catch {
    return [];
  }
}

function updateWishlistBadges() {
  const list = getWishlistList();
  const badges = document.querySelectorAll('[data-wishlist-count]');
  badges.forEach(b => {
    b.textContent = list.length;
    if (list.length > 0) {
      b.classList.add('has-items');
    } else {
      b.classList.remove('has-items');
    }
    b.classList.remove('bump');
    void b.offsetWidth; // Trigger reflow for animation
    b.classList.add('bump');
    setTimeout(() => b.classList.remove('bump'), 300);
  });

  const totalPill = document.getElementById('wishlist-total-pill');
  if (totalPill) {
    totalPill.textContent = `${list.length} ITEM${list.length === 1 ? '' : 'S'} SAVED`;
  }

  // Dispatch custom event so any custom UI or drawer can sync
  window.dispatchEvent(new CustomEvent('kiya:wishlist:updated', { detail: { count: list.length, items: list } }));
}
window.updateWishlistBadges = updateWishlistBadges;

function renderWishlistPage() {
  const grid = document.getElementById('wishlist-grid');
  const emptyState = document.getElementById('wishlist-empty-state');
  if (!grid) return;

  const rawList = getWishlistList();

  if (rawList.length === 0) {
    grid.innerHTML = '';
    if (emptyState) emptyState.classList.remove('hidden');
    return;
  }

  if (emptyState) emptyState.classList.add('hidden');

  let html = '';
  rawList.forEach(item => {
    let p;
    if (typeof item === 'object' && item !== null) {
      p = item;
    } else {
      const id = String(item);
      p = PRODUCTS_CATALOG[id] || {
        id: id,
        name: `925 Sterling Silver Piece #${id}`,
        category: "925 STERLING SILVER",
        price: "₹2,999.00",
        comparePrice: "₹3,999.00",
        discount: "25% OFF",
        image: "https://images.unsplash.com/photo-1611591475285-a36adaf961e0?q=80&w=600",
        url: "product.html",
        badge: "SAVED"
      };
    }

    html += `
      <div class="product-card wishlist-product-card" data-wishlist-card-id="${p.id}" data-product-id="${p.id}">
        <div class="product-card-image-wrapper">
          <div class="product-card-badges">
            <span class="product-card-badge badge-bestseller">${p.badge || 'SAVED'}</span>
          </div>
          <button type="button" class="btn-wishlist is-wishlisted" aria-label="Remove from Wishlist" data-remove-wishlist="${p.id}" title="Remove from Wishlist">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#B88A3B" stroke="#B88A3B" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
          </button>
          <a href="${p.url || '#'}" class="product-card-image-link">
            <img class="product-card-img" src="${p.image}" alt="${p.name}" loading="lazy" width="600" height="750">
          </a>
        </div>
        <div class="product-card-info">
          <div class="product-card-metal">${p.category || '925 STERLING SILVER'}</div>
          <h3 class="product-card-title"><a href="${p.url || '#'}">${p.name}</a></h3>
          <div class="product-card-price">
            <span class="price-current">${p.price}</span>
            ${p.comparePrice ? `<span class="compare-at-price">${p.comparePrice}</span>` : ''}
          </div>
          <div class="wishlist-card-actions">
            <button class="btn-card-action btn-quick-add" data-quick-add data-variant-id="${p.id}">+ ADD TO BAG</button>
            <button class="wishlist-remove-btn" data-remove-wishlist="${p.id}">✕ REMOVE</button>
          </div>
        </div>
      </div>
    `;
  });

  grid.innerHTML = html;

  // Add click handlers for remove buttons
  grid.querySelectorAll('[data-remove-wishlist]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const pid = btn.getAttribute('data-remove-wishlist');
      if (!pid) return;

      let currentList = getWishlistList();
      currentList = currentList.filter(item => (typeof item === 'object' ? String(item.id) : String(item)) !== String(pid));
      try {
        localStorage.setItem('kiya_wishlist', JSON.stringify(currentList));
      } catch (err) {
        console.warn(err);
      }

      // Animate card removal
      const card = grid.querySelector(`[data-wishlist-card-id="${pid}"]`);
      if (card) {
        card.style.transition = 'all 0.3s ease';
        card.style.opacity = '0';
        card.style.transform = 'scale(0.9)';
        setTimeout(() => {
          renderWishlistPage();
          updateWishlistBadges();
        }, 300);
      } else {
        renderWishlistPage();
        updateWishlistBadges();
      }
    });
  });
}
window.renderWishlistPage = renderWishlistPage;


